import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { Icon } from "Components/UI";
import { BtnContainer, Container, Content, Title } from "./styles";

interface IDeleteModal {
  visible: boolean;
  loading?: boolean;
  name: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteModal: FC<IDeleteModal> = ({
  visible,
  loading,
  name,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('editObra');

  return (
    <Modal visible={visible} width={450} footerButtons={null}>
      <Container>
        <Title>
          <span className="textTitle">
            {t('disciplines.deleteTitle', { name })}
          </span>
        </Title>

        <Content>
          <span className="contentText">
            {t('disciplines.deleteText')}
          </span>
          <span className="warningBox">
            <Icon icon="alerta" customSize={16} className="alertIcon" />
            <span className="alertText">
              {t('disciplines.deletePermanentWarning')}
            </span>
          </span>
        </Content>

        <BtnContainer>
          <Button type="text" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button
            type="primary"
            className="deleteBtn"
            onClick={onConfirm}
            primaryDanger
          >
            {loading && (
              <Spin
                indicator={
                  <LoadingOutlined
                    color="white"
                    style={{ fontSize: 12, color: 'white', marginRight: 6 }}
                  />
                }
              />
            )}
            {loading ? t('common.deleting') : t('common.delete')}
          </Button>
        </BtnContainer>
      </Container>
    </Modal>
  );
};

export default DeleteModal;
